export default {
  GET_PARKS_START: 'GET_PARKS_START',
  GET_PARKS_SUCCESS: 'GET_PARKS_SUCCESS',
  GET_PARKS_FAILURE: 'GET_PARKS_FAILURE',
  SET_CURRENT_PARKS: 'SET_CURRENT_PARKS',
  SET_CURRENT_PARK: 'SET_CURRENT_PARK',
  CLEAR_STATE: 'CLEAR_STATE',
};
